import { RECAPTCHA_SITE_KEY } from '../../../constants/auth';
import { ICustomResponse, IUserVerificationResponse } from '../../../interfaces/auth';
import { IUserCheckEmailResponse } from '../../../interfaces/responseInterface';
import type { IUserInfoResult } from '../../../interfaces/user';
import {
  CHECK_EMAIL_MOCK_RESPONSE,
  GET_INTERCOM_TOKEN_MOCK_RESPONSE,
  GET_USER_INFO_MOCK_RESPONSE
} from '../../../mocks/users';
import { HttpService } from '../../http/httpService';

interface IIntercomTokenResponse {
  token: string;
}

export class Users {
  static async resendCode(email: string): Promise<void> {
    const recaptcha = await globalThis.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: 'resend_code' });
    const headers = { 'x-recaptcha': recaptcha };
    await HttpService.post<void>('users/resend-verification-email', { email }, { headers }, {});
  }

  static async verifyEmail(email: string, code: string): Promise<IUserVerificationResponse> {
    const recaptcha = await globalThis.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: 'verify_email' });
    const headers = { 'x-recaptcha': recaptcha };
    const response = await HttpService.post<IUserVerificationResponse>(
      'users/verify-email',
      { email, code },
      { headers },
      {}
    );
    return response.data;
  }

  static async signUp(email: string, password: string, token: string): Promise<void> {
    const recaptcha = await globalThis.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: 'signup' });
    await HttpService.post<ICustomResponse>(
      'users/signup',
      { email, password, verificationToken: token, provider: 'credentials' },
      { headers: { 'x-recaptcha': recaptcha } },
      {}
    );
  }

  static async checkEmail(email: string): Promise<IUserCheckEmailResponse> {
    const recaptcha = await globalThis.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: 'check_email' });
    const headers = { 'x-recaptcha': recaptcha };
    const response = await HttpService.get<IUserCheckEmailResponse>(
      'users/check-email',
      { params: { email: email }, headers },
      CHECK_EMAIL_MOCK_RESPONSE()
    );
    return response.data;
  }

  static async getUserInfo(): Promise<IUserInfoResult> {
    const response = await HttpService.get<IUserInfoResult>('users/me', {}, GET_USER_INFO_MOCK_RESPONSE());
    return response.data;
  }

  static async getIntercomToken(): Promise<string> {
    const response = await HttpService.get<IIntercomTokenResponse>(
      'users/intercom-token',
      {},
      GET_INTERCOM_TOKEN_MOCK_RESPONSE()
    );
    return response.data.token;
  }
}

export default Users;
